import { put, select, takeEvery } from "redux-saga/effects";

import { IntegrationBusinessAction } from "actions";

import { INTEGRATION_BUSINESS } from "constants/actionTypes";

import { checkXeroActive } from "sagas/integrationCredentials";

import { getBusinessById, getIntegrationBusinessById } from "selectors";

interface LinkOptions {
  localUnlinkOnly?: boolean;
}

interface IntegrationBusinessLinkAction {
  id: number;
  businessId: string;
  options?: LinkOptions;
}

interface IntegrationBusinessUnlinkAction {
  id: number;
  options?: LinkOptions;
}

function* onLinkToBusiness(action: IntegrationBusinessLinkAction): Generator {
  const { id, businessId, options } = action;

  const state: State = (yield select()) as State;

  const integrationBusiness = getIntegrationBusinessById(id)(state);
  const newBusiness = getBusinessById(businessId)(state);

  const { businessId: oldBusinessId } = integrationBusiness;
  if (oldBusinessId && oldBusinessId !== newBusiness.id) {
    yield put(
      IntegrationBusinessAction.unlinkFromBusiness(id, oldBusinessId, {
        localUnlinkOnly: true,
      }),
    );
  }

  yield put(
    IntegrationBusinessAction.update(
      {
        id,
        businessId: newBusiness.id,
        credentialsId: integrationBusiness.credentialsId,
      },
      options,
    ),
  );
}

function* onUnlinkFromBusiness(
  action: IntegrationBusinessUnlinkAction,
): Generator {
  const { id, options } = action;

  const state: State = (yield select()) as State;
  const integrationBusiness = getIntegrationBusinessById(id)(state);

  const { localUnlinkOnly = false } = options || {};
  if (localUnlinkOnly) {
    return;
  }

  yield put(
    IntegrationBusinessAction.update(
      {
        id,
        businessId: null,
        credentialsId: integrationBusiness.credentialsId,
      },
      options,
    ),
  );
}

export default function* saga(): Generator {
  yield takeEvery(INTEGRATION_BUSINESS.SYNCHRONIZE.ACTION, checkXeroActive);
  yield takeEvery(
    INTEGRATION_BUSINESS.LINK_TO_BUSINESS.ACTION,
    onLinkToBusiness,
  );
  yield takeEvery(
    INTEGRATION_BUSINESS.UNLINK_FROM_BUSINESS.ACTION,
    onUnlinkFromBusiness,
  );
}
